<template>
  <v-container
    fluid
    class="container-fluid-scrollable">
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          :title="$t('hashtag.hashtagList')"
          color="green"
          flat
          full-width
        >
          <v-layout column>
            <v-flex md12>
              <template v-if="isManageHashtag() && !isEntityDisabled()">
                <v-btn
                  color="success"
                  dark
                  style="float: right;"
                  @click="onShowModalAddCustomerGroup(null)"
                >
                  {{ $t('common.add') }}
                </v-btn>
              </template>
            </v-flex>
            <v-flex md12>
              <div class="table-responsive-wrapper">
                <v-data-table
                  :no-data-text="$t('common.noDataAvailable')"
                  :headers="hashtagHeaders"
                  :items="hashtagList"
                  hide-actions
                  class="fixed-header-table"
                >
                  <template
                    slot="headerCell"
                    slot-scope="{ header }"
                  >
                    <span
                      v-if="header.value"
                      class="text--darken-3 font-medium"
                      v-text="$t(header.text)"
                    />
                  </template>
                  <template
                    v-slot:items="props"
                  >
                    <td
                      v-for="(header, index) in hashtagHeaders"
                      :key="header.value + index"
                      class="text-xs-center">
                      <span v-if="header.value == 'actions'">
                        <v-menu
                          v-model="props.item.selectedButton"
                          offset-y
                          transition="slide-y-transition"
                          bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              color="indigo"
                              dark
                              v-on="on">
                              <v-icon>mdi-dots-horizontal</v-icon>
                            </v-btn>
                          </template>
                          <v-card>
                            <!-- Send voucher -->
                            <v-tooltip
                              top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  :disabled="(props.item['count'] <= 0) || isEntityDisabled()"
                                  class="mx-2"
                                  fab
                                  small
                                  color="brown"
                                  style="color: #ffffff;"
                                  v-on="on"
                                  @click="onSendVoucherToHashtag(props.item)">
                                  <v-icon dark>mdi-send</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('hashtag.distributeVoucher') }}</span>
                            </v-tooltip>
                            <!-- Edit hashtag -->
                            <v-tooltip
                              top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  color="primary"
                                  style="color: #ffffff;"
                                  v-on="on"
                                  @click="onShowModalAddCustomerGroup(props.item)">
                                  <v-icon dark>mdi-account-details</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('common.detail') }}</span>
                            </v-tooltip>
                            <!-- Delete -->
                            <v-tooltip
                              top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  :disabled="!isManageHashtag() || isEntityDisabled()"
                                  class="mx-2"
                                  fab
                                  small
                                  color="red"
                                  style="color: #ffffff;"
                                  v-on="on"
                                  @click="onConfirmDeleteHashtag(props.item.id)">
                                  <v-icon dark>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('common.delete') }}</span>
                            </v-tooltip>
                          </v-card>
                        </v-menu>
                      </span>
                      <span v-else>{{ props.item[header.value] }}</span>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
            </v-layout>
          <pagination
            :total="paginate.totalPage"
            :current-page="paginate.currentPage"
            :row-per-page="paginate.rowPerPage"
            @onPageChange="onPageChange"
          />
        </material-card>
      </v-flex>
    </v-layout>
    <customerGroupDetailModal
      ref="customerGroupDetailModal"
      @onCustomerGroupChanged="onGetHashtagList"/>
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"/>
    <assignVoucherHashtagModal
      ref="assignVoucherHashtagModal"
      @transactionVoucherSuccess="onTransactionVoucherSuccess()"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CustomerGroupDetailModal from './CustomerGroupDetailModal'
import AssignVoucherHashtagModal from './../EVoucher/AssignVoucherHashtagModal'
import ToastType from 'enum/toastType'
import functionUtils from 'utils/functionUtils'
export default {
  components: {
    CustomerGroupDetailModal,
    AssignVoucherHashtagModal
  },
  data: () => ({
    hashtagHeaders: [
      {
        sortable: false,
        text: 'common.nonumber',
        value: 'stt',
        align: 'center'
      },
      {
        sortable: false,
        text: 'actions.name',
        value: 'name',
        align: 'center'
      },
      {
        sortable: false,
        text: 'hashtag.userCreated',
        value: 'userCreated',
        align: 'center'
      },
      // {
      //   sortable: false,
      //   text: 'hashtag.entityCreated',
      //   value: 'entityCreated',
      //   align: 'center'
      // },
      {
        sortable: false,
        text: 'hashtag.count',
        value: 'count',
        align: 'center'
      },
      {
        sortable: false,
        text: 'common.actions',
        value: 'actions',
        align: 'center'
      }
    ],
    hashtagList: [],
    paginate: {
      totalPage: 1,
      currentPage: 1,
      rowPerPage: 1
    },
  }),
  computed: {
    ...mapGetters([
      'CUSTOMER_GROUP_DATA',
      'GET_SNACK_BAR'
    ])
  },
  watch: {
    CUSTOMER_GROUP_DATA () {
      let res = this.CUSTOMER_GROUP_DATA
      // Handle paginate
      this.paginate.currentPage = res.paginate.currentPage
      this.paginate.totalPage = res.paginate.totalPage
      this.paginate.rowPerPage = res.paginate.perPage / 2
      // Handle response data
      let hashtagsData = res.results
      this.hashtagList = []
      for (let i = 0, size = hashtagsData.length; i < size; i++) {
        let obj = {
          stt: i + 1 + (res.paginate.currentPage - 1) * res.paginate.pageSize,
          id: hashtagsData[i].id,
          name: hashtagsData[i].name,
          userCreated: functionUtils.concatFullname(hashtagsData[i].user_created.last_name, hashtagsData[i].user_created.first_name),
          entityCreated: hashtagsData[i].entity_created.name,
          count: hashtagsData[i].number_member,
          selectedButton: false
        }
        this.hashtagList.push(obj)
      }
    }
  },
  created () {
    this.onGetHashtagList()
  },
  methods: {
    isEntityDisabled: function () {
      return functionUtils.isCurrentEntityLocked() || functionUtils.isCurrentEntityExpired()
    },
    /**
     * Show modal add customer group
     */
    onShowModalAddCustomerGroup: function (item) {
      this.$refs.customerGroupDetailModal.onShowModal(item)
    },
    /**
     * Get hashtag list
     */
    onGetHashtagList: function () {
      let filter = {
        params: {
          page: this.paginate.currentPage
        }
      }
      this.GET_CUSTOMER_GROUP_LIST(filter)
    },
    /**
     * Delete hashtag
     */
    onDeleteHashtag: function (hashtagId) {
      if (this.isEntityDisabled()) {
        return // Locked or expired entity will not able to perform these actions
      }
      this.DELETE_CUSTOMER_GROUP({ id: hashtagId }).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.onGetHashtagList()
        }.bind(this)
      ).catch(
        function (error) {
          this.ON_SHOW_TOAST({
            message: this.$t(functionUtils.errorResponse(error.response)),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    /**
     * Confirm delete hashtag
     */
    onConfirmDeleteHashtag: function (hashtagId) {
      if (this.isEntityDisabled()) {
        return // Locked or expired entity will not able to perform these actions
      }
      this.$confirmMatch({
        message: this.$t('hashtag.confirmToDelete'),
        matchText: 'DELETE',
        onConfirm: () => {
          this.onDeleteHashtag(hashtagId)
        }
      });
    },
    onTransactionVoucherSuccess: function () {
      // this.getEVoucherList()
    },
    onSendVoucherToHashtag: function (hasgtag) {
      if (this.isEntityDisabled()) {
        return // Locked or expired entity will not able to perform these actions
      }
      if (hasgtag.count > 0) {
        this.$refs.assignVoucherHashtagModal.onShowModal(hasgtag)
      } else {
        this.ON_SHOW_TOAST({
          message: this.$t('hashtag.isEmpty'),
          styleType: ToastType.ERROR
        })
      }
    },
    /**
     * Check is supplier
     */
    isManageHashtag: function () {
      return (functionUtils.isSupplierEntity() || functionUtils.isAgentEntity())
    },
    /**
     * Page change
     */
    onPageChange: function (page) {
      this.paginate.currentPage = page
      this.onGetHashtagList()
    },
    ...mapActions([
      'GET_CUSTOMER_GROUP_LIST',
      'DELETE_CUSTOMER_GROUP',
      'ON_SHOW_TOAST'
    ])
  }
}
</script>

<style lang="scss" scoped>
.table-responsive-wrapper {
  max-height: calc(100vh - 250px);
}
</style>
